import React from 'react';
import { MapToolsTab } from './DevTools/MapToolsTab';

/**
 * Map Info — current map metadata + spawn/zone inspection (MapToolsTab).
 *
 * Engine window (HUD fold, 2026-06-12): the registry provides the ToolWindow
 * chrome; this is the propless Content body.
 */
export const MapToolsContent: React.FC = () => <MapToolsTab />;
